var map = {
	"./cake.webp": 1968,
	"./crown-blue.webp": 1969,
	"./crown.webp": 1970,
	"./pocket.webp": 1971,
	"./present.webp": 1972,
	"./relegation.webp": 1973,
	"./t-deposit.webp": 1974,
	"./t-turnover.webp": 1975,
	"./vip-bg.webp": 1976,
	"./vip1.gif": 1977,
	"./vip1.webp": 1978,
	"./vip10-bg.webp": 1979,
	"./vip10.gif": 1980,
	"./vip10.webp": 1981,
	"./vip11-bg.webp": 1982,
	"./vip11.gif": 1983,
	"./vip11.webp": 1984,
	"./vip12-bg.webp": 1985,
	"./vip12.gif": 1986,
	"./vip12.webp": 1987,
	"./vip2.gif": 1988,
	"./vip2.webp": 1989,
	"./vip3.gif": 1990,
	"./vip3.webp": 1991,
	"./vip4.gif": 1992,
	"./vip4.webp": 1993,
	"./vip5.gif": 1994,
	"./vip5.webp": 1995,
	"./vip6.gif": 1996,
	"./vip6.webp": 1997,
	"./vip7.gif": 1998,
	"./vip7.webp": 1999,
	"./vip8.gif": 2000,
	"./vip8.webp": 2001,
	"./vip9.gif": 2002,
	"./vip9.webp": 2003
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 471;